import { render, staticRenderFns } from "./ProfitLossDocumentPage.vue?vue&type=template&id=25caa815&scoped=true"
import script from "./ProfitLossDocumentPage.vue?vue&type=script&lang=js"
export * from "./ProfitLossDocumentPage.vue?vue&type=script&lang=js"
import style0 from "./ProfitLossDocumentPage.vue?vue&type=style&index=0&id=25caa815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25caa815",
  null
  
)

export default component.exports